<div class="container">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>{{ title }}</h2>
     <button class="btn btn-primary" (click)="onAdd()">Add {{ addButtonLabel }}</button>
  </div>

  <div class="custom-table-wrapper">
    <table class="table table-bordered custom-table">
      <thead>
        <tr>
          <ng-container *ngFor="let col of columns">
            <ng-container *ngIf="!col.hiddenDataTable">
              <th>{{ col.displayName }}</th>
            </ng-container>
          </ng-container>
          <th>Actions</th>
        </tr>

        <!-- 🔍 Filter Row -->
        <tr>
          <ng-container *ngFor="let col of columns">
            <ng-container *ngIf="!col.hiddenDataTable">
              <th>
                <ng-container [ngSwitch]="col.type">
                  <!-- Dropdown column filter -->
                  <select
                    *ngSwitchCase="'dropdown'"
                    class="form-select form-select-sm"
                    [(ngModel)]="filters[col.key]"
                  >
                    <option value="">All</option>
                    <option *ngFor="let opt of col.options" [value]="opt.label">{{ opt.label }}</option>
                  </select>

                  <!-- Text input filter -->
                  <input
                    *ngSwitchDefault
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Search {{ col.displayName }}"
                    [(ngModel)]="filters[col.key]"
                  />
                </ng-container>
              </th>
            </ng-container>
          </ng-container>

          <!-- Reset button -->
          <th>
            <button class="btn btn-sm btn-outline-secondary" (click)="resetFilters()">
              <i class="fa fa-x"></i>
            </button>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of filteredData()">
          <ng-container *ngFor="let col of columns">
            <ng-container *ngIf="!col.hiddenDataTable">
              <td>
                <ng-container *ngIf="col.type === 'dropdown'">
                  {{ getDropdownLabel(item[col.key], col) }}
                </ng-container>
                <ng-container *ngIf="col.type !== 'dropdown'">
                  {{ col.type === 'date'
                    ? (item[col.key] | date:'yyyy-MM-dd HH:mm:ss')
                    : item[col.key] }}
                </ng-container>
              </td>
            </ng-container>
          </ng-container>
          <td>
            <button class="btn btn-secondary btn-sm" (click)="onUpdate(item)">Update</button>
            <button class="btn btn-danger btn-sm" (click)="onDelete(item)">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
